/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TerminalState = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE'
} as const;
export type TerminalState = typeof TerminalState[keyof typeof TerminalState];


export function TerminalStateFromJSON(json: any): TerminalState {
    return TerminalStateFromJSONTyped(json, false);
}

export function TerminalStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalState {
    return json as TerminalState;
}

export function TerminalStateToJSON(value?: TerminalState | null): any {
    return value as any;
}

